export const getUserDataState = (store) => store.authReducer.adminData;
